import React, { useState, useEffect } from 'react';
import StateContext from '../../helpers/ContextState';
import { useParams } from "react-router-dom";
import { PostAsync } from '../../helpers/Functions';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Graficos = () => {
    const [comprasCantidad, setComprasCantidad] = useState([]);
    const [comprasPeso, setComprasPeso] = useState([]);
    const [ventasCantidad, setVentasCantidad] = useState([]);
    const [ventasPeso, setVentasPeso] = useState([]);

    const variablesUrl = useParams();

    useEffect(() => {
        getInit();
    }, []);

    const getInit = () => {
        PostAsync("Inventario", "ResumenInicio", { idProduct: variablesUrl.idProduct })
            .then((response) => {
                setComprasCantidad(response.comprasCantidad || []);
                setComprasPeso(response.comprasPeso || []);
                setVentasCantidad(response.ventasCantidad || []);
                setVentasPeso(response.ventasPeso || []);
            });
    };

    const renderLinesByYear = (data) => {
        if (!data || !data.length) return null;

        return Object.keys(data[0])
            .filter(key => key !== 'name')
            .map((year, index) => (
                <Line
                    key={year}
                    type="monotone"
                    dataKey={year}
                    name={year}
                    stroke={index % 2 === 0 ? "#8884d8" : "#8814d1"}
                    strokeWidth={2}
                />
            ));
    };

    return (
        <div className="min-height400 row">
            <div className="row text-center mb-3">
                <h1>{variablesUrl.nameProduct}</h1>
            </div>

            <div className="row">
                <div className="col-6">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                            width={1500}
                            height={900}
                            data={comprasCantidad}
                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        >
                            <text x={350 / 2} y={15} fill="black" textAnchor="middle" dominantBaseline="central">
                                <tspan fontSize="18">Compras Cantidad</tspan>
                            </text>

                            {renderLinesByYear(comprasCantidad)}

                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                <div className="col-6">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                            width={1500}
                            height={900}
                            data={comprasPeso}
                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        >
                            <text x={350 / 2} y={15} fill="black" textAnchor="middle" dominantBaseline="central">
                                <tspan fontSize="18">Compras Peso</tspan>
                            </text>

                            {renderLinesByYear(comprasPeso)}

                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                            width={1500}
                            height={900}
                            data={ventasCantidad}
                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        >
                            <text x={350 / 2} y={15} fill="black" textAnchor="middle" dominantBaseline="central">
                                <tspan fontSize="18">Ventas Cantidad</tspan>
                            </text>

                            {renderLinesByYear(ventasCantidad)}

                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                <div className="col-6">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                            width={1500}
                            height={900}
                            data={ventasPeso}
                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        >
                            <text x={350 / 2} y={15} fill="black" textAnchor="middle" dominantBaseline="central">
                                <tspan fontSize="18">Ventas Peso</tspan>
                            </text>

                            {renderLinesByYear(ventasPeso)}

                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
};

export default Graficos;